import React from 'react';
import { Box, Button, colors, SxProps, Typography } from '@mui/material';
import { primary } from '_lex/_foundations/phxColors';
import { translate as t } from 'hooks/useTranslations';

export type PendingUpdatesAlertProps = {
  info: string;
  actionText?: string;
  onClick?: () => void;
  onAccept?: () => void;
  onReject?: () => void;
  showAcceptReject?: boolean;
  containerClass?: SxProps;
  isLoading?: boolean;
  disable?: boolean;
};

const PendingUpdatesAlert = React.memo(
  ({
    info,
    actionText,
    onClick,
    onAccept,
    onReject,
    showAcceptReject,
    containerClass,
    isLoading,
    disable,
  }: PendingUpdatesAlertProps) => {
    const handleClick = () => {
      if (onClick) onClick();
    };

    const handleAccept = () => {
      if (onAccept) onAccept();
    };

    const handleReject = () => {
      if (onReject) onReject();
    };

    return (
      <Box
        sx={{
          ...containerClass,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: 60,
          px: 8,
          border: `solid 1px ${colors.grey[200]}`,
          boxShadow: '0 8px 12px rgba(0,0,0,0.1)',
        }}
      >
        <Typography>{info}</Typography>
        {showAcceptReject ? (
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant='contained'
              color='primary'
              size='small'
              disabled={isLoading || disable}
              onClick={handleAccept}
            >
              {t('draftManuals.preface.newPreface.accept')}
            </Button>
            <Button
              variant='outlined'
              color='error'
              size='small'
              disabled={isLoading || disable}
              onClick={handleReject}
            >
              {t('draftManuals.preface.newPreface.reject')}
            </Button>
          </Box>
        ) : (
          <Box sx={{ justifyContent: 'center', alignItems: 'center' }}>
            <Button
              variant='text'
              sx={{ color: `${primary[800]}` }}
              size='small'
              disabled={isLoading || disable}
              onClick={handleClick}
            >
              {actionText}
            </Button>
          </Box>
        )}
      </Box>
    );
  }
);

export default PendingUpdatesAlert;
